import { IOperator, IOperatorId } from "operator/model"
import { operatorRPO } from "operator/repository"

export function getStringOperatorId(operatorId: IOperatorId): string {
  return `${operatorId.ssp_id}-${operatorId.publisher_id}`
}

export const getOperatorsById = (ids: string[]): Promise<IOperator[]> => operatorRPO.getOperatorsById(ids)
